import { useReducer, useEffect } from "react";
import siteIdReducer from "./reducer";
import { fetchSiteIdBySerial } from "./api";
import ACTIONS from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  siteId: null,
};

async function getSiteId(dispatch, serialNumber) {
  dispatch({ type: ACTIONS.FETCH_SITE_ID_INIT });
  try {
    const res = await fetchSiteIdBySerial(serialNumber);
    const siteId = (Array.isArray(res?.data) && (res.data[0]?.siteId || res.data[0]?.systemId)) || null;
    dispatch({ type: ACTIONS.FETCH_SITE_ID_SUCCESS, payload: siteId });
  } catch (err) {
    console.error("Error fetching siteId for serialNumber", serialNumber, err);
    dispatch({ type: ACTIONS.FETCH_SITE_ID_FAILURE });
  }
}

function useFetchSiteId(serialNumber, debounceMs = 500) {
  const [state, dispatch] = useReducer(siteIdReducer, initialState);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (serialNumber) {
        getSiteId(dispatch, serialNumber);
      }
    }, debounceMs);

    return () => clearTimeout(handler);
  }, [serialNumber, debounceMs]);

  return {
    siteId: state.siteId,
    loading: state.isLoading,
    error: state.isError,
    dispatch,
  };
}

export default useFetchSiteId;
